// extracted by mini-css-extract-plugin
export default {"infoBlock":"ReferralInfoBlock_infoBlock","text":"ReferralInfoBlock_text"};